import { Component, OnDestroy, OnInit } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import * as _ from "lodash";
import { BsModalRef } from "ngx-bootstrap/modal";
import { NgxSpinnerService } from "ngx-spinner";
import { AssetService } from "src/app/_services/asset.service";
import { LanguageTranslateService } from "src/app/_services/language-translate.service";
import { ErrorUtil } from "src/app/_utilities/error";
import { SubscriptionUtil } from "src/app/_utilities/subscription";

@Component({
    selector: 'app-add-edit-component',
    templateUrl: './add-edit-component.component.html',
    styleUrls: ['./add-edit-component.component.scss'],
    standalone: false
})
export class AddEditComponentComponent extends SubscriptionUtil implements OnInit, OnDestroy {
  translate: any;
    //=====Asset Search Component=========
  selectedIndex: any;
  showingAssetTable: boolean = false;
  assetsList: any = [];
  assets: any;
  selectedAsset: any;
 addBinForm : UntypedFormGroup[] = [];
  submitTouched: boolean;
  data:any
  updateChildAssetsWithParentAssetsValues: boolean = false;
  assetsIgnoreId: any
  constructor(
    private languageTranslateService: LanguageTranslateService,
    public modalRef : BsModalRef,
    private errorUtil: ErrorUtil,
    private spinner: NgxSpinnerService,
    private assetService: AssetService,
  ) { 
    super()
   
  }

  ngOnInit(): void {
     this.assetsIgnoreId = this.data.id;
    this.push(this.languageTranslateService.wordSrc$.subscribe(data => {
      if (Object.keys(data).length != 0) {
          this.translate = data
          this.addRow()
        }
      })
    )
  }

  /////////////////////////////// start(Asset search component)////////////////////////////
  
  gotSelectedAsset(valData: any){
    var val = valData.value ? valData.value : valData;
    this.selectAssetFromTable(val);
    this.showingAssetTable =false
  }
  closeAssetView(){
    this.showingAssetTable =false
  }
  showAssetsTable(index: any){
    this.selectedIndex = index;
    this.showingAssetTable = !this.showingAssetTable;
  }
  
  selectAssetFromTable(value: any) {//after value select from grid
  
    var check = _.filter(this.assetsList, (o) => { return o.id == value.id })
  
   console.log(check.length,"===",this.assetsList)
  
      if(check.length == 0){
        this.assetsList[this.selectedIndex].id = value.id;
        this.assetsList[this.selectedIndex].asset = value;
        this.assetsList[this.selectedIndex].serialNo = value.serialNo;
        this.assetsList[this.selectedIndex].name = value.name;
         if(value.assetsType){
          this.assetsList[this.selectedIndex].assetsType = value.assetsType;
         }
         if(value.parent){
          this.assetsList[this.selectedIndex].parent=value.parent;
         }
        
        this.assets = [];

      }else{
        this.errorUtil.setErrorMessage(200, null , this.translate?.binTransfer.messages.sameAssetBinTransferNotAllowed , 'error',3000);
      }
      console.log(this.assetsList)
  }
  

selectValueAssets(value: any,index: any) {//after value select from grid

  var check = _.filter(this.assetsList, (o) => { return o.assets.id == value.id })

 console.log(check.length)

    if(check.length == 0){
     this.assetsList[index].id = value.id;
        this.assetsList[index].asset = value;
        this.assetsList[index].serialNo = value.serialNo;
        this.assetsList[index].name = value.name;
        if(value.assetsType){
          this.assetsList[index].assetsType = value.assetsType;
        }
        if(value.parent){
          this.assetsList[index].parent = {name:value.parent.name,id:value.parent.id};
        }
        this.assets = [];
    }else{
      this.clearValueAssets(index)
      this.errorUtil.setErrorMessage(200, null , this.translate?.binTransfer.messages.sameAssetBinTransferNotAllowed, 'error',3000);
    }
    
}

  
  clearValueAssets(index: any) {
  this.assetsList[index].id = null;
  this.assetsList[index].name = null;
  this.assetsList[index].serialNo = null;
  this.assetsList[index].assetsType = null;
  this.assetsList[index].asset = {id:null};
  this.assetsList[index].parent = {name:null};
  this.addBinForm[index].reset();
  this.assets = [];
  
  this.assetsList[index].bin={id:null}
  }
  onvalidAsset(index: any){
    setTimeout(() => {
      console.log("We are checking data",this.assetsList[index])
      if(this.assetsList[index].id==null){
        this.assetsList[index].name = null;
      }
    }, 1000);
  }
  
 getAssetIdsFirstWay(event: any,index: any) {
console.log(event,"====")
var k = event.keyCode
if (k == "Backspace") {
  this.assetsList[index].asset.id = null;

}
  if (this.assetsList[index].name != null && this.assetsList[index].name.length > 2) {
    this.assetService.getAssetByFilter(this.assetsList[index].name).subscribe((data: any) => {
        this.assets = data.data;
      })
    
}

}
 
  /*=============================================== end (Asset search component)=============*/
    addRow(){
       var row;
          row =  {
            id:null,
            assetsType :  { name: null, id:null },
            name:null,
            runningNo:null,
            serialNo:null,
            parent: {name:null,id:null }
        },
         this.addBinForm[this.assetsList.length] = new UntypedFormGroup({
        'asset': new UntypedFormControl(null,[Validators.required])
        }); 
      this.assetsList.push(row);
       
      
    }
deleteAssetsRow(i: any){
    this.assetsList.splice(i, 1);
     this.addBinForm.splice(i, 1);
  }
  
  ngOnDestroy(): void {
    super.ngOnDestroy()
  }
  push(obs:any) {
    super.push(obs);
  }
  submitForm(){
    this.spinner.show();

    this.submitTouched = true;
    var check = _.filter(this.addBinForm, (o) => {
      return o.status == 'INVALID';
    })
    if( check.length > 0){
      console.log("Step 1 validation====")
    

      this.addBinForm.forEach(form => {
        if(!form.valid){
          for (var i in form.controls) {
            form.controls[i].markAsTouched();
            console.log(form.controls[i])
          }
        }
      });

    this.spinner.hide();

      this.submitTouched = false;
      return;
    }
   
  var formReq = {
    parentAsset: {id: this.data.id},
    childAssets:[],
    updateChildAssetsWithParentAssetsValues: this.updateChildAssetsWithParentAssetsValues
  }

   this.assetsList.forEach((element :any)=> {
    
      formReq.childAssets.push({
        id: element.id,
        name: element.name,
        serialNo: element.serialNo,
        assetsType: element.assetsType
      });
    
  });

this.submitTouched = true;
this.spinner.show();
console.log(formReq)

 this.assetService.createAssetComponent(formReq).subscribe((res:any) => {
      console.log(res.body)
      this.spinner.hide();
      if(res.status == 201 || res.status == 200){
        this.errorUtil.setErrorMessage(200, this.translate?.general.messages.savedSuccessfully ,  null, 'success',1000);
       this.modalRef.hide();
      } else {
        const title = this.errorUtil.processErrorTitle(res.error,this.translate)
        this.errorUtil.setErrorMessage(res.status, null ,  title, 'error',3000);
        this.submitTouched = false;
      }
    },
    (err) => {
      this.spinner.hide()
     const title = this.errorUtil.processErrorTitle(err.error,this.translate)
     this.errorUtil.setErrorMessage(err.status, null ,  title, 'error',3000);
    
  })

  }
}
